import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

const CatalogExportTile = (props) => {
  console.log("inside catalog export -------- ")
  const[renderType, setRenderType] = useState("");
    var profile = props.profile;
    const  handleCatalogExport = props.data?.[0]?.ContentRuleZone?.[0]?.attributes
    const  mainImage = props.data?.[0]?.ContentRuleZone?.[0]?.menuImage
    const  altText = props.data?.[0]?.ContentRuleZone?.[0]?.attributes?.altText

    useEffect(()=>{
      if(handleCatalogExport.renderPosition) {
        setRenderType(handleCatalogExport.renderPosition)
      }
    },[handleCatalogExport])

    const hadleCatalogExport = (event) => {
      event.preventDefault();
  }
    return (
      <>
      <li className={`text-center icon-width-popup popover__wrapper c-contact-image ${handleCatalogExport?.additionalCss ? handleCatalogExport.additionalCss :"" }`}>

      {renderType === "TextOnly"? <Link className='link-icon-style c-utility-nav-label' to={`${handleCatalogExport.link ? handleCatalogExport.link : "#"}`}>
        <span className='d-block nav-text-hover' style={{cursor:"pointer"}}>{handleCatalogExport?.displayName ? handleCatalogExport.displayName :"" }</span>
      </Link> 
        : renderType === "IconOnly" ? <Link className='link-icon-style c-utility-nav-label' to={`${handleCatalogExport.link ? handleCatalogExport.link : "#"}`}>
        {handleCatalogExport.menuIcon ? <i class={`${handleCatalogExport.menuIcon}`}></i> : mainImage ? <img src={mainImage}  alt={altText} className='menu-img'/> :""}
      </Link>
        : renderType === "LeftIconThenText" ? <Link className='link-icon-style c-utility-nav-label d-flex' to={`${handleCatalogExport.link ? handleCatalogExport.link : "#"}`}>
        {handleCatalogExport.menuIcon ? <i class={`${handleCatalogExport.menuIcon}`}></i> : mainImage ? <img src={mainImage}  alt={altText} className='menu-img'/> :""}
        <span className='d-block nav-text-hover mx-2' style={{cursor:"pointer"}}>{handleCatalogExport?.displayName ? handleCatalogExport.displayName :"" }</span>
      </Link> 
        : renderType === "LeftTextThenIcon" ? <Link className='link-icon-style c-utility-nav-label d-flex' to={`${handleCatalogExport.link ? handleCatalogExport.link : "#"}`}>
        <span className='d-block nav-text-hover mx-2' style={{cursor:"pointer"}}>{handleCatalogExport?.displayName ? handleCatalogExport.displayName :"" }</span>
        {handleCatalogExport.menuIcon ? <i class={`${handleCatalogExport.menuIcon}`}></i> : mainImage ? <img src={mainImage}  alt={altText} className='menu-img'/> :""}
      </Link> 
        : renderType === "TextAboveIcon" ? <Link className='link-icon-style c-utility-nav-label' to={`${handleCatalogExport.link ? handleCatalogExport.link : "#"}`}>
        {handleCatalogExport.menuIcon ? <i class={`${handleCatalogExport.menuIcon}`}></i> : mainImage ? <img src={mainImage}  alt={altText} className='menu-img'/> :""}
        <span className='d-block nav-text-hover mt-3' style={{cursor:"pointer"}}>{handleCatalogExport?.displayName ? handleCatalogExport.displayName :"" }</span>
      </Link>
        : renderType === "TextBelowIcon" ? <Link className='link-icon-style c-utility-nav-label ' to={`${handleCatalogExport.link ? handleCatalogExport.link : "#"}`}>
        <span className='d-block nav-text-hover mb-3' style={{cursor:"pointer"}}>{handleCatalogExport?.displayName ? handleCatalogExport.displayName :"" }</span>
        {handleCatalogExport.menuIcon ? <i class={`${handleCatalogExport.menuIcon}`}></i> : mainImage ? <img src={mainImage}  alt={altText} className='menu-img'/> :""}
      </Link> 
        : ""}

        {/* <Link className='link-icon-style c-utility-nav-label' to={`${handleCatalogExport.link ? handleCatalogExport.link : ""}`}>
          <span className='d-block nav-text-hover' style={{cursor:"pointer"}}>{handleCatalogExport?.displayName ? handleCatalogExport.displayName :"" }</span>
        </Link> */}
        {/* {props && props.targerter && <div class="popover-service-content popover__content c-targeter-content" dangerouslySetInnerHTML={{ __html: props.targerter }}>
        </div>} */}
      </li>
  
    </>
    )
}

export default CatalogExportTile